/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { multiUploadJinglesRequestModelSchema } from "../multiUploadJinglesRequestModelSchema.ts";
import { multiUploadTracksModelSchema } from "../multiUploadTracksModelSchema.ts";
import { z } from "zod";

export const postApiJingleCollectionsIdMultiUploadPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор подборки")
    })

/**
 * @description Словарь треков
 */
export const postApiJingleCollectionsIdMultiUpload200Schema = z.lazy(() => multiUploadTracksModelSchema)

/**
 * @description В запросе указаны дублирующие значения ключа | Ошибка валидации
 */
export const postApiJingleCollectionsIdMultiUpload400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiJingleCollectionsIdMultiUpload401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiJingleCollectionsIdMultiUpload403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Подборка не найдена
 */
export const postApiJingleCollectionsIdMultiUpload404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiJingleCollectionsIdMultiUpload500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiJingleCollectionsIdMultiUploadMutationRequestSchema = z.array(z.lazy(() => multiUploadJinglesRequestModelSchema)).describe("Тело запроса")

export const postApiJingleCollectionsIdMultiUploadMutationResponseSchema = z.lazy(() => postApiJingleCollectionsIdMultiUpload200Schema)